<template>
  <div class="m-edition-section-content-info-submenu m-edition-section-content-info-submenu-academy">
    <ul>
      <li>
        <router-link
          :class="[$t('mEditionMenu.academy.legals.subject') === $route.params.subject
            && $t('mEditionMenu.academy.legals.children.termsAndConditions.subedition') === $route.params.subedition
            ? 'submenu-item-active submenu-item-active-academy'
            : '']"
          :to="`/${$t('rPaths.academy')}/${$t('mEditionMenu.academy.legals.subject')}/${$t('mEditionMenu.academy.legals.children.termsAndConditions.subedition')}`"
        >
          {{ $t('mEditionMenu.academy.legals.children.termsAndConditions.subText') }}
        </router-link>
      </li>
      <li>
        <router-link
          :class="[$t('mEditionMenu.academy.legals.subject') === $route.params.subject
            && $t('mEditionMenu.academy.legals.children.emailClause.subedition') === $route.params.subedition
            ? 'submenu-item-active submenu-item-active-academy'
            : '']"
          :to="`/${$t('rPaths.academy')}/${$t('mEditionMenu.academy.legals.subject')}/${$t('mEditionMenu.academy.legals.children.emailClause.subedition')}`"
        >
          {{ $t('mEditionMenu.academy.legals.children.emailClause.subText') }}
        </router-link>
      </li>
      <li>
        <router-link
          :class="[$t('mEditionMenu.academy.legals.subject') === $route.params.subject
            && $t('mEditionMenu.academy.legals.children.privacyPolicies.subedition') === $route.params.subedition
            ? 'submenu-item-active submenu-item-active-academy'
            : '']"
          :to="`/${$t('rPaths.academy')}/${$t('mEditionMenu.academy.legals.subject')}/${$t('mEditionMenu.academy.legals.children.privacyPolicies.subedition')}`"
        >
          {{ $t('mEditionMenu.academy.legals.children.privacyPolicies.subText') }}
        </router-link>
      </li>
      <li>
        <router-link
          :class="[$t('mEditionMenu.academy.legals.subject') === $route.params.subject
            && $t('mEditionMenu.academy.legals.children.emailSignature.subedition') === $route.params.subedition
            ? 'submenu-item-active submenu-item-active-academy'
            : '']"
          :to="`/${$t('rPaths.academy')}/${$t('mEditionMenu.academy.legals.subject')}/${$t('mEditionMenu.academy.legals.children.emailSignature.subedition')}`"
        >
          {{ $t('mEditionMenu.academy.legals.children.emailSignature.subText') }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAcademyLegalsSubMenu'
}
</script>
